import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";
import { mainReducer } from "../redux/reducer";

const loggerMiddleware = createLogger();

let persistedState = {};

const store = createStore(
  mainReducer,
  persistedState,
  composeWithDevTools(applyMiddleware(thunkMiddleware, loggerMiddleware))
);

export { store };
